const appConfig = {
  apiUrl: "https://ocr-check-back.buildermind.ru/api",
};

export { appConfig };
